<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">App客户端状态管理</div>
          <span class="m-title-s">App客户端信息编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>信息列表
          </div>
          <div class="m-table-btn">
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="appState" label="开启状态" width="110" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.appState === '0'" type="success">正常</el-tag>
              <el-tag v-if="scope.row.appState === '1'" type="danger">关闭</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题" width=""></el-table-column>
          <el-table-column prop="explain" label="说明" width=""></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="750px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="formLoading">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入标题"></el-input>
            </el-form-item>
            <el-form-item label="说明: " prop="explain">
              <el-input v-model="form.explain" placeholder="输入说明"></el-input>
            </el-form-item>
            <el-form-item label="开启状态: " prop="isStatus">
              <el-switch v-model="isStatus" active-text="开启" inactive-text="关闭"></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'appState',
  data () {
    return {
      openText: '',
      openState: false,
      formLoading: false,
      isLoading: false,
      isStatus: false,
      list: [],
      form: {
        title: '',
        explain: '',
        appState: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        money: [
          {required: true, message: '请输入价格', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    audioDuration (e) {
      this.form.duration = e.duration
    },
    closeDialog: function () {
      this.form = {
        title: '',
        explain: '',
        appState: ''
      }
      this.isStatus = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.appState = this.isStatus ? '0' : '1'
          _this.formLoading = true
          this.$axios.post('/appState/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.loadData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
              }
            })
        } else {
          return false
        }
      })
    },
    openForm (row) {
      this.openText = '编辑'
      this.form = {
        title: row.title,
        explain: row.explain,
        appState: row.appState
      }
      this.isStatus = row.appState === '0'
      this.openState = true
    },
    // 管理员列表
    loadData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/appState/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/appState/AppState.vue